// extracted by mini-css-extract-plugin
export default {"mainContainer":"Widget_mainContainer__dX8aE","innerContainer":"Widget_innerContainer__lp2yN","singContainer":"Widget_singContainer__-+lz-","widgetTitle":"Widget_widgetTitle__HV5WE"};